/**
 * Roster-builder constants shared by every lobby flow (online H2H, deck
 * builder, local PvP, bot setup). Single source of truth so future tweaks
 * (e.g., raising MIN_SLOTS to require a backup pitcher) only land here.
 */

export const TEAM_NAME_MAX = 24;

// Default lineup the randomize / save flow uses. Order matters — the position
// dropdown preserves the slot order until the user reorders manually.
export const DEFAULT_SLOTS = ["P", "P", "C", "1B", "2B", "3B", "SS", "LF", "CF", "RF", "DH"];

// Roster size bounds. MAX_SLOTS caps the Add Slot button; MIN_SLOTS gates
// Remove (and powers the "Need at least N players" tooltip).
export const MAX_SLOTS = 16;
export const MIN_SLOTS = 9;
